// Google Analytics
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

ga('create', 'UA-55967228-1', 'auto');
ga('require', 'ecommerce'); // PAYL-2389

var getCookie = function(name) {
    var nameEqual = name + "=";
    var cookieArray;
    if (document.cookie && typeof document.cookie === "string") {
        cookieArray = document.cookie.split(";");
        for (var ii = 0; ii < cookieArray.length; ii++) {
            var cookie = cookieArray[ii];
            while (cookie.charAt(0) == " ") {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(nameEqual) == 0) {
                return cookie.substring(nameEqual.length, cookie.length);
            }
        }
    }
    return null;
};

const amplitude = require('amplitude-js');
if (document.getElementById("AMPLITUDE_CLIENT_SIDE_ID")) {
    amplitude.getInstance().init(document.getElementById("AMPLITUDE_CLIENT_SIDE_ID").textContent, null, {
        includeUtm: true,
        includeReferrer: true,
        includeGclid: true,
        unsetParamsReferrerOnNewSession: true,
    });
}
